import { graphql } from 'react-apollo';
import gql from 'graphql-tag';
import { compose, withProps } from 'recompose';

import ExcelTicketSummary from '../../../components/ExcelTicketSummary';
import queryMetaHandler from '../../../utils/queryMetaHandler';


export const SubmissionItemQuery = gql`
  query SubmissionItem($submissionItemId: Int!) {
    submission_item(id: $submissionItemId) {
      id
      documentId: document_id
    }
  }
`;


const queryData = graphql(SubmissionItemQuery);


const mapDataToProps = withProps((props) => {
  const { documentId } = props.data.submission_item;
  return {
    documentId,
  };
});


export const querySubmissionItemGQL = compose(
  queryData,
  queryMetaHandler,
  mapDataToProps,
);


export const rotateDocumentPage = gql`
  mutation DocumentPageRotate($input: DocumentPageRotateInput!) {
    document_page_rotate(input: $input) {
      id
      uploadedFiles: uploaded_files {
        edges {
          node {
            id
            url: view_url
            contentType: content_type
            thumbnailUrl: thumbnail_url
            pageIndex: page_index
            excelTicketSummary: excel_ticket_summary {
              ...Summary
            }
          }
        }
      }
    }
  }
  ${ExcelTicketSummary.fragment}
`;


export const rotateDocumentPageMutation = (client, documentId, pageIndex, rotateDirection) => {
  const variables = {
    input: {
      document_id: documentId,
      page_index: pageIndex,
      rotation_direction: rotateDirection,
    },
  };

  const options = {
    mutation: rotateDocumentPage,
    variables,
  };

  return client.mutate(options);
};
